import { Animation, Container3D, Mesh3D } from "pixi3d/pixi7";
import { Container3DExtentions } from "../../../../../extensions/Container3DExtentions";
import { QuaternionExtentions } from "../../../../../extensions/QuaternionExtentions";
import { DiceDirectionDescription } from "../../configurations/DiceDirectionDescription";
import { DiceResult } from "../../models/DiceResult";
import gsap from "gsap";

export class Dice extends Container3D {
    private readonly diceViewObject: Container3D;
    private animation: Animation;
    private diceThrown: boolean;
    public readonly mesh: Mesh3D;

    public constructor(diceAsset: Container3D, diceMeshName: string, diceViewObjectName: string) {
        super();
        this.mesh = Container3DExtentions.findByName<Mesh3D>(diceAsset, diceMeshName);
        if (this.mesh == null) {
            throw new Error("Failed to parse dice container. Due to incorrect structure or naming.");
        }
        this.diceViewObject = Container3DExtentions.findByName(diceAsset, diceViewObjectName);
        if (this.diceViewObject == null) {
            throw new Error("Failed to parse dice container. Due to incorrect structure or naming.");
        }
        this.diceThrown = false;
        this.addChild(diceAsset);
    }

    public insureResult(requiredResult: DiceResult, simulationResult: DiceResult): void {
        const simulationDirection = DiceDirectionDescription.diceResultToBodyDirection(simulationResult);
        const requiredDirection = DiceDirectionDescription.diceResultToBodyDirection(requiredResult);
        this.diceViewObject.rotationQuaternion.copyFrom(QuaternionExtentions.fromToRotation(requiredDirection, simulationDirection));
    }

    public throwDice(animation: Animation): Promise<void> {
        this.position.set(0, 0, 0);
        return new Promise<void>((resolve, reject) => {
            try {
                this.animation = animation;
                this.animation.once("complete", resolve, this);
                this.animation.speed = 2;
                this.animation.play();
                this.diceThrown = true;
            } catch (e) {
                reject(e);
            }
        });
    }

    public async collectDice(): Promise<void> {
        if (!this.diceThrown) {
            throw new Error('Can\'t collect dice that wasn\'t thrown.');
        }
        this.position.y = 3;
        this.diceThrown = false;
    }

}
